import Data from "../types/Data";

export default function getItemsByIds(data: Data, ids: number[]) {
  return ids.map((id) => data.Item[id]);
}
